import { render, staticRenderFns } from "./AvatarImage.vue?vue&type=template&id=17a5015e&"
import script from "./AvatarImage.vue?vue&type=script&lang=js&"
export * from "./AvatarImage.vue?vue&type=script&lang=js&"
import style0 from "./AvatarImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports